// Define the color mapping for each Y value (series)
export const colorMapping: Record<string, string> = {
  "IKEA meubelmontage": "#5AAF5C",
  "IKEA badkamer installatie": "#457DA0",
  "IKEA apparatuur installatie": "#FFCB4A",
  "IKEA B2B Meubelmontage": "#DA70D6",
  "IKEA B2B Keukeninstallatie": "#FFAA39",
  "Leenbakker meubelmontage": "#5AAF5C",
};

export const praxisColorMapping: Record<string, string> = {
  "Praxis laminaat leggen": "#457DA0",
  "Praxis laminaat leggen completed": "#5AAF5C",
};

export const leenbakkerColorMapping: Record<string, string> = {
  "Leenbakker meubelmontage MODULE": "#457DA0",
  "Leenbakker meubelmontage API": "#5AAF5C",
};